import React from 'react';

import SelectableGrid from '../../Shared/SelectableGrid/SelectableGrid';

const MonthGrid = (props) => {
  const { footer, onSelect, selectableMonths, selectAll, selectedMonths } =
    props;

  return (
    <SelectableGrid
      id="month-chart"
      btnSize={64}
      phoneColNum={3}
      options={selectableMonths}
      optionName="Months"
      onSelect={onSelect}
      selectAll={selectAll}
      selectedOptions={selectedMonths}
      title="Frequency"
      footer={footer}
    />
  );
};

export default MonthGrid;
